<template>
  <CCard class="mb-3">
    <CCardHeader>Calidad de datos</CCardHeader>
    <CCardBody>
      <div class="quality-grid">
        <div class="quality-item" v-for="item in items" :key="item.key">
          <div class="quality-label">{{ item.label }}</div>
          <div class="quality-value">{{ number(item.value) }}</div>
          <div class="quality-description">{{ item.description }}</div>
        </div>
      </div>

      <div class="mt-3">
        <CBadge :color="dataQuality.warning ? 'warning' : 'success'" class="quality-badge">
          {{ dataQuality.warning ? 'Atencion requerida' : 'Calidad aceptable' }}
        </CBadge>
      </div>

      <CAlert color="warning" class="mt-3 mb-0" v-if="dataQuality.warning">
        {{ dataQuality.warning_message || 'La calidad de datos puede afectar los resultados.' }}
      </CAlert>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: 'WebhookDataQualityCard',
  props: {
    dataQuality: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    items() {
      return [
        {
          key: 'total_messages',
          label: 'Mensajes analizados',
          value: this.dataQuality.total_messages,
          description: 'Total de mensajes incluidos en el reporte para calcular indicadores.',
        },
        {
          key: 'messages_without_delivery_event',
          label: 'Sin entrega',
          value: this.dataQuality.messages_without_delivery_event,
          description: 'Mensajes sin evidencia de entrega en eventos/webhooks.',
        },
        {
          key: 'messages_without_read_event',
          label: 'Sin lectura',
          value: this.dataQuality.messages_without_read_event,
          description: 'Mensajes entregados que no registran lectura.',
        },
        {
          key: 'messages_with_duplicate_webhooks',
          label: 'Webhooks duplicados',
          value: this.dataQuality.messages_with_duplicate_webhooks,
          description: 'Mensajes con eventos repetidos para el mismo estado.',
        },
        {
          key: 'messages_without_identifier',
          label: 'Sin identificador',
          value: this.dataQuality.messages_without_identifier,
          description: 'Mensajes sin WAMID u otro identificador confiable.',
        },
        {
          key: 'messages_with_inconsistent_dates',
          label: 'Fechas inconsistentes',
          value: this.dataQuality.messages_with_inconsistent_dates,
          description: 'Registros con secuencia temporal invalida (ej. lectura antes de envio).',
        },
        {
          key: 'scheduled_without_execution_related',
          label: 'Programados sin ejecucion',
          value: this.dataQuality.scheduled_without_execution_related,
          description: 'Envios programados sin request de ejecucion asociado.',
        },
      ]
    },
  },
  methods: {
    number(value) {
      return Number(value || 0).toLocaleString('es-MX')
    },
  },
}
</script>

<style scoped>
.quality-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 10px;
}

.quality-item {
  border: 1px solid #ece7d8;
  border-radius: 8px;
  background: #fcfaf5;
  padding: 10px;
}

.quality-label {
  font-size: 12px;
  color: #6d664f;
}

.quality-value {
  font-size: 20px;
  font-weight: 700;
  color: #3f4b5f;
}

.quality-description {
  margin-top: 6px;
  font-size: 11px;
  line-height: 1.35;
  color: #7a7460;
}

.quality-badge {
  font-size: 12px;
  padding: 6px 10px;
}
</style>
